angular.module('mtic')
.service('DataPathService', function ($log) {
  return {
    'class/module/student/work': function(class_id, module_id, student_id){ return '/class/'+class_id+'/module_id/'+module_id+'/student/'+student_id+'/work' },
    'class/module/student/workSummary': function(class_id, module_id, student_id){ return '/class/'+class_id+'/module_id/'+module_id+'/student/'+student_id+'/workSummary' },
    'class/module/work': function(class_id, module_id, from, to, limit){ return '/class/'+class_id+'/module/'+module_id+'/work/from/' + from + '/to/'+to + '/limit/' + limit },
    'class/work': function(class_id){ return '/class/'+class_id+'/work' },
    'class/modulesMapContainer': function(class_id){ return '/class/'+class_id+'/moduleMapContainer' },
    'class/modulesListFlat': function(class_id){ return '/class/'+class_id+'/modulesListFlat' },
    'class/modulesListFlatMap': function(class_id){ return '/class/'+class_id+'/modulesListFlatMap' },
    'class/student/work': function(class_id, student_id){ return '/class/'+class_id+'/student/'+student_id+'/work' },
    'class/teacher/work': function(class_id, teacher_id){ return '/class/'+class_id+'/teacher/'+teacher_id+'/work' },
    'class/users/app/events': function(class_id, from, to, limit){ return '/class/'+class_id+'/users/app/events/from/' + from + '/to/'+to + '/limit/' + limit },
    'user/students_c3custom': function(class_id){ return '/user/'+class_id+'/students_c3custom' },
    'class/students': function(class_id){ return '/class/'+class_id+'/students' },
    'class/studentsMap': function(class_id){ return '/class/'+class_id+'/studentsMap' },
    'class/workSummarized': function(class_id){ return '/class/'+class_id+'/workSummarized' },
    'user/classes': function(user_id){ return '/user/'+user_id+'/classes' },
    'user/schools': function(user_id){ return '/user/'+user_id+'/schools' },

    dynamic: function(key, params){
      var parsedKey = key;
      _.map(params, function(param, paramName){
        parsedKey = parsedKey.replace(new RegExp(':'+paramName,'g'), param)
      })
      $log.debug('[[DataPathService]]', key, params, parsedKey)
      return parsedKey;
    }
  }
});
